import apiClient from '../client';
import {SearchResult} from '../../slices/search/types';

export const fetchSearchSuggestions = async (term: string): Promise<string[]> => {
    try {
        const response = await apiClient.get('search/suggestions', {params: {term}});
        return response.data as string[];
    } catch (error) {
        throw new Error('error');
    }
};

export const fetchSearchResults = async (term: string): Promise<SearchResult[]> => {
    try {
        const response = await apiClient.get('search', {params: {term}});
        return response.data as SearchResult[];
    } catch (error) {
        throw new Error('error');
    }
};
